module.exports = __webpack_public_path__ + "img/circle-check.aca02794.svg";